import React from 'react';
import Stats from '../../../components/stats';
import AreaChartComponent from '../../../components/Charts/AreaChart';
import { getDateFromTimestamp } from '../../../utilities/datetime';
import EmptyState from '../../../components/EmptyState';

const index = ({ data, performance_summary }) => {
  const values =
    data &&
    data.map((item) => {
      /**
       * @TODO: Make this component use a single data format and modify all the usages to send in a single data format.
       */
      let usd = 0;
      if (item?.total?.USD) {
        usd = item.total.USD;
      } else if (!isNaN(parseInt(item.total))) {
        usd = item.total;
      }

      return {
        name: getDateFromTimestamp(Number(item.time)),
        USD: usd,
      };
    });

  const items =
    values &&
    values.filter((item) => {
      return item.USD !== 0;
    });

  return (
    <>
      <div className="home_card quaterly-performance" style={{ height: '405px' }}>
        <div>
          <span className="heading_text">Defi Quarterly Performances</span>
        </div>
        {performance_summary && <Stats data={performance_summary} />}
        {values && values.length > 0 && items.length ? (
          <AreaChartComponent data={values} performance_summary={performance_summary} />
        ) : (
          <div className="empty_state_charts">
            {' '}
            <EmptyState />{' '}
          </div>
        )}
      </div>
    </>
  );
};

export default index;
